import axiosClient from '../axiosClient';

const bookingAPI = {
    async getList(params) {
        const url = `/booking`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async findOne(id, params) {
        const url = `/booking/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async create(data) {
        const url = `/booking`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async update(id, data) {
        const url = `/booking/${id}`;
        const resp = await axiosClient.put(url, data);
        return resp;
    },

    async remove(id) {
        const url = `/booking/${id}`;
        const resp = await axiosClient.delete(url);
        return resp;
    },

    async removeMulti(params) {
        const url = `/booking`;
        const resp = await axiosClient.delete(url, { params });
        return resp;
    },

    async getListBookingAPI(params) {
        const url = `/booking`;
        const res = await axiosClient.get(url, { params });
        return res;
    },
};

export default bookingAPI;
